export class GridIcons{
	refresh: string = "fa fa-refresh";
	
	sortingAsc: string = "fa fa-sort-asc text-primary";
	sortingDesc: string = "fa fa-sort-desc text-primary";
	
	firstPage: string = "fa fa-step-backward";
	firstPageTitle: string = "First page";
	
	prevPage: string = "fa fa-caret-left";
	prevPageTitle: string = "Previous page";

	nextPage: string = "fa fa-caret-right";
	nextPageTitle: string = "Next page";

	lastPage: string = "fa fa-step-forward";
	lastPageTitle: string = "Last page";
}